import { Medicine } from '@hdcorner/ui-library';

const concatMedicine = (medicine: Medicine) => {
  return `${medicine.medicineName} - ${medicine.medicineType} - ${medicine.content}`;
};

export { concatMedicine };
